module.exports = __webpack_public_path__ + "img/quattrocento_sans+quattrocento.814bd4e0.png";